import { ApiUrl2, UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (mediaid, type, fileName) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });
    //debugger
    const data = new FormData();
    data.append('media-id', mediaid);

    const Authorization = UserToken;
    const url = ApiUrl2 + 'media-id-download-file';
    const argument = {
        method: 'POST',
        headers: {
            'Authorization': Authorization,
        },
        body: data
    };
    //debugger
    const response = await doFetch(url, argument);
    var responseText 
    if (response.ok) {
      responseText = await response.text();
        //debugger
    }

    if (window.navigator.msSaveBlob) {
        // IE 10 and later, and Edge.
        var blobObject = new Blob([responseText], {type:type});
        window.navigator.msSaveBlob(blobObject, fileName);
    } else {
        // Everthing else (except old IE).
        // Create a dummy anchor (with a download attribute) to click.
        var anchor = document.createElement('a');
        anchor.download = fileName;
        if (window.URL.createObjectURL) {

            const byteCharacters = atob(responseText);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], {type: type});
            anchor.href = window.URL.createObjectURL(blob);

        }

        if (document.createEvent) {
            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            anchor.dispatchEvent(event);
        } else {
            anchor.click();
        }
    }



    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus: response.ok });
    return response;
};